/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import {
  createStore,
  applyMiddleware,
  compose,
} from 'redux';

import createSagaMiddleware from 'redux-saga';
import { middleware as thunkMiddleware } from 'redux-saga-thunk';

export const sagaMiddleware = createSagaMiddleware();

export default function configureStore( initialState = {} ) {
  const enhancer = compose(
    applyMiddleware( thunkMiddleware, sagaMiddleware ),
  );

  const store = createStore( () => {}, initialState, enhancer );

  // sagaMiddleware.run( rootSaga );
  return store;
}



// WEBPACK FOOTER //
// ./src/store.js